export const SEGUIMINETO_APORTES_ERROR = 'SEGUIMINETO_APORTES_ERROR';
export const SEGUIMINETO_APORTES_EXITOSO = 'SEGUIMINETO_APORTES_EXITOSO';
export const SEGUIMINETO_APORTES_LOADING = 'SEGUIMINETO_APORTES_LOADING';
export const SEGUIMINETO_APORTES_CLEAN = 'SEGUIMINETO_APORTES_CLEAN';